<template>
  <offer-layout>
    <error @click="login">
      <heading level="2" class="title" slot="title">{{ t('title') }}</heading>
      <div class="subtitle" slot="subtitle">{{ t('subtitle') }}</div>
      <i18n class="message" path="errors.emailUsed.message" tag="div" slot="message">
        <brand-link
          :href="phoneNumberLink"
          class="phoneNumber"
          slot="phoneNumber"
          v-text="phoneNumber"
        />
        <span slot="workHours">{{ workHours }}</span>
      </i18n>
      <span class="buttonLabel" slot="buttonLabel">{{ t('buttonLabel') }}</span>
    </error>
  </offer-layout>
</template>
<script>
import OfferLayout from '@/views/layouts/OfferLayout';
import Error from '@/components/Error';
import buildTranslators from '@/utils/build-translators';

export default {
  components: {
    OfferLayout,
    Error,
  },
  data() {
    return {
      phoneNumber: this.$env.VUE_APP_PARTNER_PHONE,
      workHours: this.$env.VUE_APP_PARTNER_WORK_HOURS,
    };
  },
  computed: {
    phoneNumberLink() {
      return `tel://${this.phoneNumber}`;
    },
  },
  methods: {
    async login() {
      await this.$router.push({ name: 'login' });
    },
    t(key, options) {
      return buildTranslators('errors.emailUsed').t(key, options);
    },
  },
};
</script>
<style lang="sass" scoped></style>
